import { render, staticRenderFns } from "./OPayButton.vue?vue&type=template&id=7f1b28b6&"
import script from "./OPayButton.vue?vue&type=script&lang=js&"
export * from "./OPayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports